import { useRouter } from 'next/router';
import useUserAppointments from './useUserAppointments';

export function useSessionAppointmentId(bypassAuditCheck?: boolean) {
  const { query } = useRouter();

  const appt_id = Number(Buffer.from(`${query.req}`, 'base64').toString());

  const { userAppointments } = useUserAppointments('USER_APPOINTMENTS', {
    appt_id,
    team: !!query.team
  });

  if (bypassAuditCheck) return appt_id;

  const appointment = userAppointments?.payload?.[0];

  return appointment?.audit_appt_id || appt_id;
}
